import { useContext } from 'react';
import { userAuth } from '../contexts/userContext';
import { useNavigate } from 'react-router-dom';
import { getConfig } from '../config';

// Common API service to make requests to the web API.
const CommonAPIService = () => {
    
    // Get user authentication context and navigation context.
	const { token, setToken } = useContext(userAuth);
	const navigate = useNavigate();

	// fetch request to common API
	async function sendRequest(quary) {
		//const web_link = process.env.REACT_APP_WEB_LINK;
		const web_link = getConfig().REACT_APP_WEB_LINK;
		return fetch(web_link, {
			method: 'post',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				'sdk-authorization': `${token.session_key}`,
			},
			body: JSON.stringify(quary),
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				return response.json();
			})
			.then((response) => {
				// if token expired, remove it from local storage and navigate to login page
				if (response.type === 'error' && response.message === 'Session expired') {
					setToken({});
					localStorage.removeItem('user-auth');
					navigate('/');
				}
				return response;
			});
	}

    return { sendRequest };
};

export default CommonAPIService;
